import { LinkTo } from '@ember/routing';
import { t } from 'ember-intl';

const currentYear = new Date().getFullYear();

<template>
  <footer class="site-footer">
    <div class="container">
      <div
        class="site-footer__inner"
        vocab="https://schema.org/"
        typeof="Organization"
      >
        <div class="site-footer__section">
          <h2 class="footer-heading">{{t "site.title"}}</h2>
          <p property="description">
            {{t "footer.description"}}
          </p>
          <meta property="name" content="DEVLOED.COM" />
          <meta property="url" content="https://devloed.com" />
          <link
            property="sameAs"
            href="https://www.linkedin.com/in/borisdevloed/"
          />
          <link property="sameAs" href="https://github.com/bdevloed" />
        </div>

        <div class="site-footer__section">
          <h2 class="footer-heading">{{t "footer.navigation"}}</h2>
          <nav aria-label="Footer navigation">
            <ul class="footer-nav-list">
              <li><LinkTo @route="index">{{t "navigation.home"}}</LinkTo></li>
              <li><LinkTo @route="services">{{t
                    "navigation.services"
                  }}</LinkTo></li>
              <li><LinkTo @route="experience">{{t
                    "navigation.experience"
                  }}</LinkTo></li>
              <li><LinkTo @route="publications">{{t
                    "navigation.publications"
                  }}</LinkTo></li>
              <li><LinkTo @route="contact">{{t
                    "navigation.contact"
                  }}</LinkTo></li>
              <li><LinkTo @route="privacy">{{t
                    "navigation.privacy"
                  }}</LinkTo></li>
            </ul>
          </nav>
        </div>

        <div
          class="site-footer__section"
          property="address"
          typeof="PostalAddress"
        >
          <h2 class="footer-heading">{{t "footer.legal_info"}}</h2>
          <address class="address-normal">
            <strong>DEVLOED.COM</strong><br />
            {{t "contact.company_info.legal_form"}}<br />
            <span property="streetAddress">Floridalaan 77 bus 10</span><br />
            <span property="postalCode">1180</span>
            <span property="addressLocality">Ukkel</span><br />
            <span property="addressCountry">Belgium</span><br /><br />
            <strong>{{t "contact.company_info.kbo_number"}}</strong>
            0759.557.312<br />
            <strong>{{t "footer.rpr"}}</strong>
            {{t "footer.rpr_court"}}<br />
            <strong>{{t "contact.company_info.vat"}}</strong>
            BE 0759.557.312
          </address>
        </div>

        <div class="site-footer__section">
          <h2 class="footer-heading">{{t "footer.connect"}}</h2>
          <div class="social-links">
            <a
              href="https://www.linkedin.com/in/borisdevloed/"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="LinkedIn (opens in new window)"
              title="LinkedIn"
              class="social-link"
            >
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="currentColor"
                aria-hidden="true"
              >
                <path
                  d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"
                />
              </svg>
            </a>
            <a
              href="https://github.com/bdevloed"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="GitHub (opens in new window)"
              title="GitHub"
              class="social-link"
            >
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="currentColor"
                aria-hidden="true"
              >
                <path
                  d="M12 0C5.374 0 0 5.373 0 12c0 5.302 3.438 9.8 8.207 11.387.599.111.793-.261.793-.577v-2.234c-3.338.726-4.033-1.416-4.033-1.416-.546-1.387-1.333-1.756-1.333-1.756-1.089-.745.083-.729.083-.729 1.205.084 1.839 1.237 1.839 1.237 1.07 1.834 2.807 1.304 3.492.997.107-.775.418-1.305.762-1.604-2.665-.305-5.467-1.334-5.467-5.931 0-1.311.469-2.381 1.236-3.221-.124-.303-.535-1.524.117-3.176 0 0 1.008-.322 3.301 1.23A11.509 11.509 0 0112 5.803c1.02.005 2.047.138 3.006.404 2.291-1.552 3.297-1.23 3.297-1.23.653 1.653.242 2.874.118 3.176.77.84 1.235 1.911 1.235 3.221 0 4.609-2.807 5.624-5.479 5.921.43.372.823 1.102.823 2.222v3.293c0 .319.192.694.801.576C20.566 21.797 24 17.3 24 12c0-6.627-5.373-12-12-12z"
                />
              </svg>
            </a>
          </div>
        </div>
      </div>

      <div class="site-footer__bottom">
        <p>&copy; {{currentYear}} DEVLOED.COM. {{t "footer.copyright"}}</p>
      </div>
    </div>
  </footer>
</template>
